
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/twilio-engage/journeys",
      function () {
        return require("private-next-pages/product/twilio-engage/journeys.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/twilio-engage/journeys"])
      });
    }
  